import UIActions from "../UIActions"
import strings from "../../locale/strings"

const toastDuration = 15000

export function showCsvConfirmation() {
  UIActions.success(strings.cycle.csvEmailToast, toastDuration)
}
